import React, { useRef } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    Chip,
} from "@mui/material";
import { LINKAGE } from "./prepUi";

const Row = ({ label, children }) => (
    <Box sx={{ display: "flex", gap: 2, py: 0.75 }}>
        <Typography variant="body2" color="text.secondary" sx={{ minWidth: 120, flexShrink: 0 }}>
            {label}
        </Typography>
        <Box sx={{ minWidth: 0 }}>{children}</Box>
    </Box>
);

const Value = ({ value, mono }) =>
    value ? (
        <Typography variant="body2" sx={{ fontFamily: mono ? "monospace" : undefined, wordBreak: "break-all" }}>
            {value}
        </Typography>
    ) : (
        <Typography variant="body2" sx={{ color: "text.disabled" }}>—</Typography>
    );

// ETT-email info for a single student, opened from the info icon in a matrix column header.
const StudentEttInfoModal = ({ open, onClose, student }) => {
    // Retain the last non-null student so the Dialog can play its close animation: the parent
    // clears `student` and flips `open` to false in the same update, so rendering the cached
    // student keeps the content mounted through the exit transition instead of vanishing.
    const lastStudent = useRef(student);
    if (student) lastStudent.current = student;
    const s = student || lastStudent.current;
    if (!s) return null;

    const lk = s.linkage ? LINKAGE[s.linkage.status] : null;
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ pb: 0.5 }}>
                {s.name || s.email}
                {s.consultation_number != null && s.consultation_number !== ""
                    ? ` (${s.consultation_number})`
                    : ""}
            </DialogTitle>
            <DialogContent dividers>
                <Row label="ETT email">
                    <Value value={s.ett_email} mono />
                </Row>
                <Row label="Account email">
                    <Value value={s.email} mono />
                </Row>
                {s.linkage ? (
                    <Row label="Linkage">
                        <Chip
                            size="small"
                            color={lk?.color || "default"}
                            label={lk?.label || s.linkage.status || "unknown"}
                        />
                    </Row>
                ) : null}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default StudentEttInfoModal;
